import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query niboCategories($integrationId: Int, $page: Int) {
    niboCategories(integrationId: $integrationId, page: $page, limit: 30) {
      id
      name
    }
  }
`

export const useCategorySelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'niboCategories']))
      .then(data => {
        return data
      })
  }
}

const CategorySelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useCategorySelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default CategorySelect
